'use client';
import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';

import { cn } from '@playbooks/ui/lib/utils';

function TooltipProvider({ delay = 0, ...props }: TooltipPrimitive.Provider.Props) {
	return <TooltipPrimitive.Provider data-slot='tooltip-provider' delay={delay} {...props} />;
}
function Tooltip({ ...props }: TooltipPrimitive.Root.Props) {
	return <TooltipPrimitive.Root data-slot='tooltip' {...props} />;
}
function TooltipTrigger({ ...props }: TooltipPrimitive.Trigger.Props) {
	return <TooltipPrimitive.Trigger data-slot='tooltip-trigger' {...props} />;
}
function TooltipContent({
	className,
	side = 'top',
	sideOffset = 4,
	align = 'center',
	alignOffset = 0,
	children,
	...props
}: TooltipPrimitive.Popup.Props &
	Pick<TooltipPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>) {
	// Theme
	const rootClassName = cn(
		'z-flyout inline-flex w-fit max-w-xs origin-(--transform-origin) items-center gap-1.5 rounded-panel bg-foreground px-3 py-1.5 text-xs text-canvas has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-flyout **:data-[slot=kbd]:rounded-control data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95',
		className,
	);

	// Render
	return (
		<TooltipPrimitive.Portal>
			<TooltipPrimitive.Positioner
				alignOffset={alignOffset}
				side={side}
				sideOffset={sideOffset}
				align={align}
				className='isolate z-flyout'>
				<TooltipPrimitive.Popup data-slot='tooltip-content' {...props} className={rootClassName}>
					{children}
					<TooltipPrimitive.Arrow className='z-flyout size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-control bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=inline-end]:top-1/2! data-[side=inline-end]:-left-1 data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-right-1 data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5' />
				</TooltipPrimitive.Popup>
			</TooltipPrimitive.Positioner>
		</TooltipPrimitive.Portal>
	);
}
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
